// removed by extract-text-webpack-plugin
module.exports = {"pageContainer":"Footer-module__pageContainer___1jepi","footer":"Footer-module__footer___3FHIk","footer__mainText":"Footer-module__footer__mainText___3gSjS"};


//////////////////
// WEBPACK FOOTER
// ./src/app/components/Footer/Footer.module.css
// module id = 629
// module chunks = 0